import { useCallback } from 'react'
import { Chip, Stack } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { GlobalNotificationTab, setGlobalNotificationTab } from '../../../reducer/globalNotification.reducer'
import { selectGlobalNotificationTab, selectGlobalNotifications } from '../../../selectors/globalNotification'
import { GlobalNotificationType } from '../../../proto/generated/global-notification'

const TAB_ITEMS: { key: GlobalNotificationTab; label: string; type: GlobalNotificationType }[] = [
    { key: GlobalNotificationTab.SYSTEM_NOTIFICATION, label: 'System Alerts', type: GlobalNotificationType.SYSTEM_NOTIFICATION },
    { key: GlobalNotificationTab.PRODUCT_ANNOUNCEMENT, label: 'Updates', type: GlobalNotificationType.PRODUCT_ANNOUNCEMENT }
]

const GlobalNotificationHeader = () => {
    const dispatch = useDispatch()
    const selectedGlobalNotificationTab = useSelector(selectGlobalNotificationTab)
    const notifications = useSelector(selectGlobalNotifications)

    const handleTabChange = useCallback(
        (tab: GlobalNotificationTab) => {
            dispatch(setGlobalNotificationTab(tab))
        },
        [dispatch]
    )

    return (
        <Stack direction="row" flexWrap="wrap" rowGap={1}>
            {TAB_ITEMS.map(({ key, label, type }) => {
                const count = notifications.filter((n) => n.type === type).length
                return (
                    <Chip
                        key={key}
                        label={count > 0 ? `${label} (${count})` : label}
                        clickable
                        sx={{ mr: 1, fontWeight: 500 }}
                        onClick={() => handleTabChange(key)}
                        variant={selectedGlobalNotificationTab === key ? 'filled' : 'outlined'}
                    />
                )
            })}
        </Stack>
    )
}

export default GlobalNotificationHeader
